import React from 'react'
import { Button, IconWrap } from '~ui';

const colors = ['yellow', 'blue', 'green', 'red']

export default function HighlightsItemColor({ color, onChange }) {
    return (
        <div className={'ui-highlight-colors'}>
            {colors.map(c=>(
                <Button variant='ghost'
                    key={c}
                    data-active={c == color || (!color && c=='yellow')}
                    onClick={()=>onChange({ color: c })}>
                    <IconWrap 
                        className={'ui-highlight-color'} 
                        style={{'--color': c}} />
                </Button>
            ))}
        </div>
    )
}